const radioFieldset = document.querySelector("fieldset.radio");
const regionSelect = document.querySelector("select[name='region']");
const sourceSelect = document.querySelector("select[name=where_do_you_listen_0]");
const autoCompleteDiv = document.getElementById("autocomplete");
const podcastSelect = document.querySelector("select[name=where_do_you_listen_2]");
const podcastSpan = podcastSelect.parentElement;

const preselectedSource = sourceSelect.value;
const preselectedPodcast = podcastSelect.value;
const preselectedStation = document.querySelector('fieldset.radio').dataset['customStation'] || null;
console.log("PRESELECTED SOURCE", preselectedSource);
console.log("PRESELECTED PODCAST", preselectedPodcast);
console.log("PRESELECTED STATION", preselectedStation);

// initialize the form on page load
function initializeStationSelect() {

  sourceSelect.value = preselectedSource || "Select…";
  const autoCompleteInput = autoCompleteDiv.querySelector("input");
  if (autoCompleteInput !== null) {
	autoCompleteInput.value = "";
  }
  autoCompleteDiv.style.display = "none";

  // if initializing following form error
  if (preselectedStation) {
	sourceSelect.value = 'Radio';
    hideShowStationSelect();
	if (autoCompleteInput !== null) {
	  autoCompleteInput.value = preselectedStation;
	}
  }
}

function initializePodcastSelect() {
  podcastSelect.value = preselectedPodcast || "";
  podcastSpan.style.display = "none";
  if (preselectedPodcast) {
	sourceSelect.value = "podcast";
	hideShowPodcastSelect();
	podcastSelect.value = preselectedPodcast;
  }
}

function hideShowPodcastSelect() {
  podcastSelect.value = "";
  if (sourceSelect.value === "podcast") {
	podcastSpan.style.display = "block";
  } else {
	podcastSpan.style.display = "none";
  }
}

function hideShowStationSelect() {
  if (sourceSelect.value === 'Radio') {
    autoCompleteDiv.style.display = "block";
  } else {
    autoCompleteDiv.style.display = "none";
	autoCompleteDiv.querySelector("input").value = "";
	document.querySelector("input[name=where_do_you_listen_1]").value = "";
  }
}


// eventListeners
document.addEventListener("DOMContentLoaded", initializeStationSelect);
document.addEventListener("DOMContentLoaded", initializePodcastSelect);
regionSelect.addEventListener("change", initializeStationSelect);
sourceSelect.addEventListener("change", hideShowStationSelect);
sourceSelect.addEventListener("change", hideShowPodcastSelect);






